import React from 'react';

interface Hub {
  label: string;
  url: string;
}

interface RelatedHubsProps {
  title?: string;
  hubs?: Hub[];
}

export const RelatedHubs: React.FC<RelatedHubsProps> = ({ title = 'Related hubs', hubs }) => {
  if (!hubs?.length) return null;

  return (
    <div className="flex flex-col gap-4">
      <p className="tc-subheading my-0">{title}</p>
      {hubs.map((hub, index) => (
        <a
          key={index}
          href={hub.url}
          className="border-dark-100 text-dark-200 bg-neutral hover:border-primary hover:shadow-primary/10 active:bg-background-300 flex h-[50px] w-full items-center rounded-md border p-4 text-[16px] font-bold transition-all hover:shadow-xl active:shadow-none"
        >
          {hub.label}
        </a>
      ))}
    </div>
  );
};
